import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import type { IntlShape } from 'react-intl';
import browserFallbackIconSrc from '../assets/browsers/browser.avif';
import chromeIconSrc from '../assets/browsers/chrome.avif';
import safariIconSrc from '../assets/browsers/safari.avif';

// return type required because we're using multiple versions of next.js
const getBrowserData = (intl: IntlShape, browserName?: string): { buttonText: string; src: StaticImport } => {
  if (browserName?.toLowerCase().includes('chrome')) {
    return { src: chromeIconSrc, buttonText: intl.formatMessage({ defaultMessage: 'Continue in Chrome' }) };
  }

  if (browserName?.toLowerCase().includes('safari')) {
    return { src: safariIconSrc, buttonText: intl.formatMessage({ defaultMessage: 'Continue in Safari' }) };
  }

  return { src: browserFallbackIconSrc, buttonText: intl.formatMessage({ defaultMessage: 'Continue in browser' }) };
};

export default getBrowserData;
